import { useViewContext } from '../../../../lib/context/ViewContext';
import { CourseDetailsProps } from './CourseDetails.types';
import CourseDetailsView from './CourseDetailsView';
import ErrorInfo from '../../base/ErrorInfo/ErrorInfo';
import { isNil } from '../../../../lib/utils/isNil';
import SkeletonCourseDetailsView from './SkeletonCourseDetailsView';
import { PageType } from '../../../../lib/hooks/usePageDetails';
import { Api } from '../../../../lib/types/apiSpec';
import { replaceObjectPlaceholders } from '../../../../lib/utils/placeholders/replacePlaceholder';

const CourseDetails = ({ id, associateAssetDialogTitle, ...rest }: CourseDetailsProps) => {
  const { page, isLoading, isValidating } = useViewContext();
  const { course, learningPath, type } = page;

  if (isLoading) {
    return <SkeletonCourseDetailsView />;
  }

  if (page.error) {
    return <ErrorInfo error={page.error} />;
  }

  if (type === 'general' || (isNil(learningPath) && isNil(course))) {
    return null;
  }

  return (
    <>
      {type === PageType.CourseDetails && (
        <CourseDetailsView
          {...rest}
          type={Api.TrainingType.Course}
          trainingName={course?.name ?? ''}
          originalId={course?.originalId}
          description={course?.description}
          courseId={course?.id ?? ''}
          listElements={course?.modules}
          associatedAssets={course?.libraryEntries ?? []}
          isValidating={isValidating}
          associateAssetDialogTitle={replaceObjectPlaceholders(page, associateAssetDialogTitle)}
        />
      )}
      {type === PageType.LearningPathDetails && (
        <CourseDetailsView
          {...rest}
          type={Api.TrainingType.LearningPath}
          trainingName={learningPath?.name ?? ''}
          originalId={learningPath?.originalId}
          description={learningPath?.description}
          courseId={learningPath?.id ?? ''}
          listElements={learningPath?.courses}
          associatedAssets={learningPath?.libraryEntries ?? []}
          extraAssociatedAssets={learningPath?.courses?.flatMap(c => c.libraryEntries ?? []) ?? []}
          isValidating={isValidating}
          associateAssetDialogTitle={replaceObjectPlaceholders(page, associateAssetDialogTitle)}
        />
      )}
    </>
  );
};

export default CourseDetails;
